import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriversService } from '../root/drivers.service';
import { ActiveDriver } from '../types';

@Pipe({
  name: 'userFromPhone',
})
export class UserFromPhonePipe implements PipeTransform {
  constructor(private driverService: DriversService) {}

  // tslint:disable-next-line
  transform(phone: string): Observable<ActiveDriver> {
    return this.driverService.activeDriverList$.pipe(
      map((activeDrivers) => {
        return (activeDrivers || []).find((driver) => driver.phoneNumber === phone);
      }),
    );
  }
}
